import * as React from "react"
import { Link } from "gatsby"
import { StoreContext } from "../context/store-context"
import Logo from "../icons/logo"
import { Navigation } from "./navigation"
import { CartButton } from "./cart-button"
import SearchIcon from "../icons/search"
import Hamburger from "../icons/hamburger"

import { slide as Menu } from 'react-burger-menu'

import { Toast } from "./toast"
import {
  header,
  container,
  logo as logoCss,
  searchButton,
  nav,
  hamburger,
  bar
} from "./header.module.css"

function MobileMenu(props) {
  return(
  <Menu right width={'100vw'} customBurgerIcon={<Hamburger />}>
  <div className="columns-1 flex float-right	">
    <br />
    <Link
      to="/"
      className="float-right text-5xl mt-5 mr-5 flex text-white"
    >
      <h1>Home</h1>
    </Link><br/>
    <Link
      key="All"
      to="/products/"
      className="float-right text-5xl mt-5 mr-5 flex text-white"
    >
      <h1>Shop</h1>
    </Link><br/>
    <Link
      key="All"
      to="/FAQ/"
      className="float-right text-5xl mt-5 mr-5 flex text-white"
    >
      <h1>FAQ</h1>
    </Link><br/>
    <Link
      to="/cart/"
      className="float-right text-5xl mr-5 mt-5 flex text-white"
    >
      <h1>Cart</h1>
    </Link>

  </div>
</Menu>)
}


export function Header() {
  const { checkout, loading, didJustAddToCart } = React.useContext(StoreContext)

  const items = checkout ? checkout.lineItems : []


  const quantity = items.reduce((total, item) => {
    return total + item.quantity
  }, 0)

  return (
      <div className=" border-b-2 border-black">
        <header className={header}>
          <Link className='visible p-2' to="/">
            <Logo />
          </Link>
           
          <div className="hidden md:inline-flex items-center ">

            </div>
            <div className="flex order-last justify-end md:hidden">
              <MobileMenu />
            </div>
        </header>
        <div className="w-full h-8 border-t-2 flex item-center flex-row border-black bg-white">
        <Link to="/" className="border-r-2 hover:bg-pink-600 hover:text-white border-black">
              <p className="flex pt-1 flex-col px-3 font-bold">HOME</p>
            </Link>
        <Link to="/faq" className="border-r-2 hover:bg-pink-600 hover:text-white border-black">
              <p className="flex pt-1  flex-col px-3 font-bold">FAQ</p>
            </Link>
            <Link to="/products" className="border-r-2 hover:bg-pink-600 hover:text-white border-black">
              <p className="flex pt-1  px-3 flex-col font-bold">SHOP</p>
            </Link>
            <CartButton quantity={quantity} />

        </div>
        <Toast className=""show={loading || didJustAddToCart}>
          {!didJustAddToCart ? (
            "Updating…"
          ) : (
            <>
              Added to cart{" "}
              <svg
                width="14"
                height="14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M5.019 10.492l-2.322-3.17A.796.796 0 013.91 6.304L6.628 9.14a1.056 1.056 0 11-1.61 1.351z"
                  fill="#fff"
                />
                <path
                  d="M5.209 10.693a1.11 1.11 0 01-.105-1.6l5.394-5.88a.757.757 0 011.159.973l-4.855 6.332a1.11 1.11 0 01-1.593.175z"
                  fill="#fff"
                />
                <path
                  d="M5.331 7.806c.272.326.471.543.815.163.345-.38-.108.96-.108.96l-1.123-.363.416-.76z"
                  fill="#fff"
                />
              </svg>
            </>
          )}
        </Toast>
    
      </div>
  )
}
